import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import {
  numberInputOnWheelPreventChange,
  currencyFormatter,
  extractURLAndEncodedFilename,
  isValidFileName,
  // downloadFileFromS3,
} from "../../utils/helper";
import { Modal as AntModal } from "antd";

import downloadFileFromS3 from "../../utils/helper";

const defaultPart = {
  cncMaterial: null,
  cncSurfaceFinish: null,
  cncHeatTreatment: null,
  cncTolerance: null,
  cncPartMarking: null,
  cncReviewMyDesign: null,
  cncInternalCorner: null,
  threeDTechnology: null,
  threeDMachine: null,
  threeDMaterial: null,
  threeDPostProcessing: null,
  qty: 1,
  partNotes: '',
  description: '',
  partName: '',
  selectedFile: null,
  importedselectedFile: null,
  twoDFile: null,
  importedtwoDFile: null,
};



import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  fetchRFQById,
  getAllSuppliers,
  updateRFQPartsData,
  createSupplierRFQ,
  getSupplierRFQsForRFQ,
  handleUpdateRfQ,
  sendRFQToSupplier,
  markRFQAsSent,
  deleteRFQ,
  downloadRfq,
  createPurchaseOrder,
  updateRFQAdminComment,
  cancelRFQ,
  deleteFileFromRFQ,
  getPOBySupplierRFQId,
  uploadRFQDocumentByAdmin,
  activateRFQ,
  getOfferSupplierDetailsByQuoteId,
  downloadBatchFileSupplier,
  getDataSupplier,
  updateOfferAndRFQProjectName,
  getOtherRFQOfferData,
} from "../../utils/actions/supplierActions";
import Sidebar from "../Sidebar";
import {
  fetchQuoteById,
  getMaterial,
  getOrderForQuotationId,
  getQuoteDetails,
  processFileWithAnalysis,
} from "../../utils/actions/allactions";
import downloadImg from "../../images/download.svg";
import deleteImageEnabled from "../../images/reddelete.svg";
import Switch from "react-input-switch";
import ChatButton from "../../Chat/ChatButton";
import Chat from "../../Chat";
import { ChatRefContext } from "../../context/chatRef.context";
import { Button, Modal, Row, Col, Form, Table } from "react-bootstrap";
import moment from "moment";
import useDocumentTitle from "../../utils/useDocumentTitle";
import CaptchaModal from "../../components/CaptchaModal/CaptchaModal";
import { Loading } from "../../components/Loading";
import { DeleteIcon, DownloadIcon, EditIcon, LucidLoader, UploadIcon } from "../../components/Icons";
import RFQTableMasterMaterial from "../../components/RfqDetailsTableComponent/RFQTableMasterMaterial";
import { maxFileUploadSize } from "../../utils/constant";
import { getAllMaterialsList, getPresignedUrlForFile } from "../../api/helperapi/helperApi";
import { deletePartSnapShotDataOfferRFQ, uploadFileToRFQ, uploadPartSnapShotDataOfferRFQ } from "../../api/supplier/rfqs/adminRfqApi";
import { fetchOrganzationDetails, getData, getDFMInfo } from "../../api/customer/masters/commonMastersApi";
import { fetchApi } from "../../utils/actions/commanActions";
import PartOfferRfqMetaDataChange from "../../components/OfferRfqDetails/PartOfferRfqMetaDataChange";
import { getAllMachineDataWithPopulation, getAllTechnology } from "../../utils/actions/adminActions";
import MetaDataInfoThreeDComponent from "../../components/OfferRfqDetails/MetaDataInfoThreeDComponent";
import MetaDataInfoCncComponent from "../../components/OfferRfqDetails/MetaDataInfoCncComponent";
import { getQuotePartsDataById } from "../../api/customer/quotation/commonQuotationApi";
import ThreeDViewerComponent from "../../components/ViewerComponent/ThreeDViewerComponent";
import PartName from "../../components/PartName/PartName";
import BackButtonWarning from "../../components/BackButtonComponent/BackButtonWarning";
import { getOrganizationAddresses } from "../../api/customer/masters/adminMastersApi";
import EmailModal from "../EmailModal/EmailModal";
import FileImportModal from "../../components/FileImportLoader/FileImportLoader";
import FileName from "../../components/FileNameWithDownloadAndDelete/FileNameWithDownloadAndDelete";
import { useNavigationGuard } from "../../CustomHooks/useNavigationGuard";
import { useUnsavedChanges } from "../../context/UnsavedChangesContext";
import RFQOfferEditProjectName from "../../components/EditProjectName/RFQOfferEditProjectName";
import GenericLoaderComponent from "../Loading/GenericLoaderComponent";
import PDFModalViewer from "../../components/PDFViewerModal/PDFModalViewer";

const RFQDetails = () => {
  const token = localStorage.getItem("Token");
  const [isDownloadRfq, setIsDownloadRfq] = useState(false);
  const navigate = useNavigate();
  useDocumentTitle("RFQ Details");
  const { isDirty, setIsDirty } = useUnsavedChanges();
  const { _id } = useParams();
  const [rFQData, setRFQData] = useState(null);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [supplierList, setSupplierList] = useState([]);
  const [supplierRFQs, setSupplierRFQs] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showRfqModal, setShowRfqModal] = useState(false);
  const [rFQtoShow, setRFQToShow] = useState(null);
  const [selectedEmailListForSupplier, setSelectedEmailLIstForSupplier] = useState([]);
  console.log("Selected Email ::", selectedEmailListForSupplier);
  const [isSupplierRFQUpdating, setSupplierRFQUpdaing] = useState(false);
  const [downloadingRfqIndex, setDownloadingRFQIndex] = useState(null);
  const [showRfqOfferEditProjectName, setShowRfqOfferEditProjectName] = useState(false);
  console.log("Rfq :", rFQtoShow);
  const [poId, setPoId] = useState('');

  const { setSelectedChatRefId, selectedChatRefId, setChatType } =
    useContext(ChatRefContext);
  const [isPOAlreadyExists, setIsPoAlreadyExist] = useState(false);

  console.log("Is PO Created :", isPOAlreadyExists);
  const [showDeclineDescription, setShowDeclineDescription] = useState(false);
  const [isAnyFileImporting, setIsAnyFileImporting] = useState(false);
  const [captchaCallback, setCaptchaCallback] = useState(() => { });
  const [buttonText, setButtonText] = useState('');
  const [isDfmInfoLoading, setIsDfmInfoLoading] = useState(false);
  const [isMaterialDataLoading, setIsMaterialDataLoading] = useState(false);

  const [isSave, setIsSave] = useState(false);
  const [declinedRFQData, setDeclinedRFQData] = useState({});
  const [purchaseOrder, setPurchaseOrder] = useState({});
  const [isRFQUpdatable, setIsRFQUpdatable] = useState(true);
  const [isPartsNameChanged, setIsPartsNameChanged] = useState(false);
  const [showCaptchaModal, setShowCaptchaModal] = useState(false);
  const [selectedRFQForMail, setSelectedRFQForMail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isNewRowCreated, setNewRowCreated] = useState(false);
  const [fullMastersData, setFullMastersData] = useState({});
  const [isAnySupplierRFQCreated, setIsAnySupplierRFQCreated] = useState(false);
  const [is3DFileOn, setIs3DFileOn] = useState(false); // State for 3D file toggle
  const [is2DFileOn, setIs2DFileOn] = useState(false); // State for 2D file toggle
  const [isAddLineItemModalShow, setIsLineItemModalShow] = useState(false);
  const [isQuoteListModalOpen, setIsQuoteListModalOpen] = useState(false);
  // const [selectedQuote, setSelectedQuote] = useState(null);
  const [allCncMachineData, setAllCncMachineData] = useState(null);
  const [masterThreeDTechnologyData, setMasterThreeDTechnologyData] = useState([]);
  const [isAnyUnsavedChanges, setIsAnyUnsavedChange] = useState(false);
  const [rfqOfferAdditionalData, setRfqOfferAdditionalData] = useState('');
  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  });


  const inputRefs = useRef([]);

  useEffect(() => {
    setIsDirty(isAnyUnsavedChanges);
  }, [isAnyUnsavedChanges]);
  const [isDefaultOrganizationAddressExists, setIsDefaultOrganizationAddressExists] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const addressData = await getOrganizationAddresses();
        if (addressData.status) {
          const defaultAddress = addressData.data.find(address => address.isDefault);
          if (defaultAddress) {
            setIsDefaultOrganizationAddressExists(true);
          }
        }
      } catch (error) {
        console.error("Error fetching organization address:", error);
      }
    })()

  }, []);

  console.log("Master data in useEffect rfq details ::", masterThreeDTechnologyData);

  useEffect(() => {
    if (isSave) {
      setIsSave(false);
      handleUpdateRFQPartData();
    }

  }, [isSave, rFQData]);

  const ErrorCheckHOF = (callback) => {
    return (...args) => {
      if (isAnyUnsavedChanges) {
        toast.error("There are unsaved changes. Please save them to continue.");
        return;
      }
      callback(...args);
    };
  };





  const handleQuoteListModalClick = () => {
    setIsQuoteListModalOpen((pre) => !pre);
  };
  useEffect(() => {
    if (isNewRowCreated) {
      const fetchDataforNewRow = async () => {
        try {
          setIsLoading(true);
          let formData = new FormData();
          formData.append("updatedRFQ", JSON.stringify(rFQData));

          let updatedRFQResponse = await updateRFQPartsData(formData, token);
          if (updatedRFQResponse?.data?.status) {
            setIsPartsNameChanged(false);
            toast.success("New row created successful");
            fetchData();
          } else {
            toast.error(updatedRFQResponse?.data?.data?.message);
          }

        } catch (error) {
          toast.error("Unable to created new row at the moment");
        } finally {
          setIsLoading(false);
          setNewRowCreated(false);
        }
      }
      fetchDataforNewRow();
    }
  }, [isNewRowCreated]);

  const handleMetaDataSave = (index, newData) => {

    console.log("New Data :", newData);
    setRFQData((item) => {
      const newPartData = item?.partsData?.map((item, idx) => {
        if (idx == index) {
          return { ...item, ...newData };
        }
        return item;
      })
      const updatedData = {
        ...item,
        partsData: newPartData
      };
      console.log("Updated Data :", updatedData);
      return updatedData;
    });
    setIsSave(true);
  };

  const handleNewRowCreating = async () => {
    if (isPOAlreadyExists) {
      toast.error("Po is already created");
      return;
    }
    if (isAnySupplierRFQCreated) {
      const confirmProceed = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Add New Row',
          content: 'Supplier RFQ is already created. Are you sure you want to add a new row?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      }); if (!confirmProceed) return;
    };

    const dropDownObject = {};



    if (rFQData?.selectedProcess == 1) {

      console.log("All Machine Data :", allCncMachineData);

      const outOfSpecMachine = allCncMachineData?.find(item => item?.cnc_machine?.toLowerCase() == 'outofspec');
      console.log("Machine :", outOfSpecMachine)
      const defaultMaterial = outOfSpecMachine?.cnc_materials?.find((item => item?.cnc_material?.toLowerCase() == 'Aluminum'?.toLowerCase() && item?.cnc_grade?.toLowerCase() == 'AL 7075'?.toLowerCase()));
      console.log("Material :", defaultMaterial)

      const defaultHeatTreatment = defaultMaterial?.cnc_heat_treatment[0];
      const defaultInternalCorner = defaultMaterial?.cnc_internal_corners[0];
      const defaultPartMarking = defaultMaterial?.cnc_part_marking[0];
      const defaultReviewMyDesign = defaultMaterial?.cnc_review_my_design[0];
      const defaultSurfaceFinish = defaultMaterial?.cnc_surface_finish[0];
      const defaultTolerance = defaultMaterial?.cnc_tolerance[0];
      dropDownObject.cncMaterial = defaultMaterial?._id;
      dropDownObject.cncSurfaceFinish = defaultSurfaceFinish?._id;
      dropDownObject.cncHeatTreatment = defaultHeatTreatment?._id
      dropDownObject.cncTolerance = defaultTolerance?._id
      dropDownObject.cncPartMarking = defaultPartMarking?._id
      dropDownObject.cncInternalCorner = defaultInternalCorner?._id;
      dropDownObject.cncReviewMyDesign = defaultReviewMyDesign?._id;
    }
    else if (rFQData?.selectedProcess == 2) {
      const defaultTech = masterThreeDTechnologyData?.find(item => item?.name?.toLowerCase() == 'mjf');
      const defaultMachine = defaultTech?.machines?.find((item) => item?.name?.toLowerCase() == 'Out of Spec Dimensions'?.toLowerCase());
      const defaultMaterial = defaultMachine?.materials?.find((item) => item?.name?.toLowerCase() == 'PA12'?.toLowerCase());
      const defaultPostProcess = defaultMaterial?.postProcess?.find(item => item?.name?.toLowerCase()?.includes('As Printed'?.toLowerCase()));
      dropDownObject.threeDTechnology = defaultTech?._id
      dropDownObject.threeDMachine = defaultMachine?._id
      dropDownObject.threeDMaterial = defaultMaterial?._id
      dropDownObject.threeDPostProcessing = defaultPostProcess?._id;
    }

    console.log('Object :', dropDownObject);
    setRFQData((rfqData) => {
      const newData = {
        ...rfqData,
        partsData: [...rfqData.partsData, { ...defaultPart, ...dropDownObject }]
      };
      return newData;
    })
    setNewRowCreated(true);
  };

  const handleLineItemModalClick = () => {
    setIsLineItemModalShow((pre) => !pre);
  };
  const handleClone = (index) => {
    setRFQData((rfqData) => {
      const newPartsData = rfqData.partsData[index];
      delete newPartsData._id;
      const newData = {
        ...rfqData,
        partsData: [...rfqData.partsData, newPartsData],
      };
      return newData;
    });
    setNewRowCreated(true);
  }

  useEffect(() => {
    (async () => {
      try {
        await fetchData();
      } catch (err) {
        console.log(
          "Error in 83 RFQ Details on " +
          moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
          err
        );
        toast.error("Something went wrong while loading the page");
        setIsLoading(false);
      }
    })()
  }, []);
  const [isBatchFileDownloading, setIsBatchFileDownloading] = useState(false);


  const handleBatchClick = async () => {
    setIsLoading(true);
    try {
      const response = await downloadBatchFileSupplier(_id, 'rfq-offer');

      const blob = new Blob([response], { type: 'application/zip' });
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `batch_download_${rFQData?.type || ""}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      toast.error("Failed to download batch file at the moment");


    } finally {
      setIsLoading(false);
    }

  }

  const handleCloseCaptchaModal = () => {
    setShowCaptchaModal(false);
    setSelectedRFQForMail("");
  };

  const handleSendRFQEmail = ErrorCheckHOF((selectedRFQForMail, emails) => {
    console.log("Emails is ::", emails);
    try {
      handleSendRFQMail(selectedRFQForMail, emails);
      setSelectedRFQForMail("");
    } catch (err) {
      console.log("err", err);
    }
  });
  const handleAddItemFromQuoteList = (item) => {
    const newData = {
      threeDTechnology: item.threeDTechnology || null,
      threeDMachine: item.threeDMachine || null,
      threeDMaterial: item.threeDMaterial || null,
      threeDPostProcessing: item.threeDPostProcessing || null,
      cncMaterial: item.cncMaterial || null,
      cncTolerance: item.cncTolerance || null,
      cncParkMarking: item.cncParkMarking || null,
      cncReviewMyDesign: item.cncReviewMyDesign || null,
      cncSurfaceFinish: item?.cncSurfaceFinish || null,
      cncHeatTreatment: item?.cncHeatTreatment,
      cncInternalCorner: item?.cncInternalCorner,
      thumbnail: item.thumbnail || null,
      mainPrice1: item.price1 || 0,
      mainPrice2: item.price2 || 0,
      mainPrice3: item.price3 || 0,
      mainPartDataId: item?._id,
    };
    if (is3DFileOn) {
      newData.selectedFile = item.selectedFile || null;
      newData.importedselectedFile = item.selectedFile || null;
    }
    else {
      newData.importedselectedFile = item.selectedFile || null;
    }
    if (is2DFileOn) {
      newData.twoDFile = item.twoDFile || null
      newData.importedtwoDFile = item.twoDFile || null
    }
    else {
      newData.importedtwoDFile = item.twoDFile || null
    };
    setRFQData((rfqData) => {
      const newRfqData = {
        ...rfqData,
        partsData: [...rfqData.partsData, { ...newData }]
      };
      return newRfqData;
    })
    handleQuoteListModalClick();
    handleLineItemModalClick();
    setNewRowCreated(true);
  }
  const showSupplierDrawer = (RefId) => {
    setSelectedChatRefId(RefId);
    setChatType("supplier");
  };

  const onClose = () => {
    setChatType(null);
    setSelectedChatRefId(null);
  };

  const handleRFQModelShow = (id, status) => {
    if (status == "Active Order") {
      setIsRFQUpdatable(false);
    }
    if (status == "Unapproved") {
      setIsRFQUpdatable(false);
    }
    if (status == "Cancelled") {
      setIsRFQUpdatable(false);
    }
    supplierRFQs.forEach((item) => {
      if (item._id == id) {
        setRFQToShow(item);
        setShowRfqModal(true);
      }
    });
  };

  const handleModalClose = () => {
    // let localRFQPartsData = [...rFQtoShow.partsData];
    // localRFQPartsData.forEach((item) => {
    //   item.price = 0;
    // });
    // let totalPrice = 0;

    // setRFQToShow({
    //   ...rFQtoShow,
    //   partsData: localRFQPartsData,
    //   price: totalPrice,
    // });

    setRFQToShow(null);
    setShowRfqModal(false);
  };
  const handleDeleteRow = (index) => {
    if (isPOAlreadyExists) {
      toast.error("Po already created");
      return;
    }
    if (rFQData.partsData?.length == 1) {
      toast.error("At least one line item is required");
      return;
    }
    setRFQData((rfq) => {
      return {
        ...rfq,
        partsData: [...rfq.partsData].filter((_, idx) => idx != index)
      };
    });
  }
  const fetchDfmInfo = async (partsData) => {
    console.log("Parts data ::", partsData);
    const ids = partsData?.map((item) => item?.stagingPartsDataId).filter(Boolean);
    setIsDfmInfoLoading(true);
    try {
      const res = await getDFMInfo(ids);
      const dfmData = res?.data;

      const updatedPartsData = partsData.map((part) => {
        const stagingPartsDataId = part?.stagingPartsDataId;
        if (stagingPartsDataId && dfmData[stagingPartsDataId]) {
          return {
            ...part,
            ...(dfmData[stagingPartsDataId]?.data || {}),
          };
        }
        return part;
      });
      setRFQData((pre) => {
        return {
          ...pre,
          partsData: updatedPartsData,
        }
      });



    } catch (err) {
      console.log("Val ::", err);
    }
    finally {
      setIsDfmInfoLoading(false);
    }
  };
  const fetchMaterialData = async (type) => {
    if (!type) return;
    try {
      setIsMaterialDataLoading(true);
      const materialListResponse = await getAllMaterialsList(type);
      if (materialListResponse) {
        setFullMastersData(materialListResponse);
      }

    } catch (error) {

    } finally {
      setIsMaterialDataLoading(false);
    }

  }
  const fetchSecondaryData = async (quoteId) => {

    try {
      const quoteDataResponse = await getData([
        {
          modelName: 'quotes',
          fields: ['partsData', 'price1', 'price2', 'price3', 'selectedProcess'],
          "filter": { "_id": quoteId },
        }
      ], 'getdata quote data for offer ');
      if (!quoteDataResponse.success) return;
      const { results } = quoteDataResponse;
      const data = results?.quotes?.[0];
      const type = data?.selectedProcess == 1 ? "CNC" : data?.selectedProcess == 2 ? "3D Printing" : "Both";
      setSelectedQuote(data);
      if (data?.selectedProcess == 1) {
        fetchMaterialData(type);
        getAllMachineDataWithPopulation().then(response => setAllCncMachineData(response.data)).catch(console.error);

      }
      else if (data?.selectedProcess == 2) {
        getAllTechnology().then(response => setMasterThreeDTechnologyData(response.data)).catch(console.error);

      }
      const response = await getOtherRFQOfferData(token, quoteId, 'offer');
      if (response?.success) {
        const { success, ...data } = response;
        console.log("Setting data ::", data);
        setRfqOfferAdditionalData(data);
      }
    } catch (error) {
      console.error("Error fetching secondary data:", error);
      toast.error("Failed to fetch quote data");
    }
  };
  const handleProjectNameEdit = async (projectName) => {
    setIsLoading(true);
    try {
      setShowRfqOfferEditProjectName(false);
      const data = {
        _id: rFQData._id,
        projectName: projectName,
      };
      const res = await updateOfferAndRFQProjectName(token, data);
      console.log("Response from update project name :", res);
      if (res.success) {
        toast.success("Project name updated successfully");
        setRFQData((prevData) => ({
          ...prevData,
          projectName: projectName,
        }));
      };
    } catch (error) {
      toast.error("Failed to update project name");
      console.error("Error updating project name:", error);
    } finally {
      setIsLoading(false);
    }
  }
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await getDataSupplier([
        {
          "modelName": "rfqOfferModel",
          "filter": { "_id": _id },
        },
        {
          "modelName": "supplierRFQOfferModel",
          "filter": {
            "rfqOfferId": _id,
            poCreationDate: { $exists: true, $ne: null }
          },
        },
      ]);
      if (!res.success) return;
      const { results } = res;
      const rfqData = results?.rfqOfferModel?.[0];
      const poData = results?.supplierRFQOfferModel?.[0]
      // const offerResponse = await fetchOfferById(_id, token);
      console.log("Data :", rfqData);
      console.log("Po data ::", poData);
      setRFQData(rfqData);
      setIs3DFileOn(rfqData.Import3D);
      setIs2DFileOn(rfqData.Import2D);
      setIsPoAlreadyExist(!!poData);
      fetchSecondaryData(rfqData?.quotationId);
      fetchDfmInfo(rfqData.partsData);

      const supplierRFQResponse = await getSupplierRFQsForRFQ(token, _id);
      if (supplierRFQResponse.status) {
        setSupplierRFQs(supplierRFQResponse.data);
        let supplierRFQForPO = "";
        supplierRFQResponse.data.forEach((item) => {
          if (item.isSelected) {
            supplierRFQForPO = item._id;
          }
        });

        if (supplierRFQForPO.length > 0) {
          let poResponse = await getPOBySupplierRFQId(token, supplierRFQForPO);
          if (poResponse.status) {
            setPurchaseOrder(poResponse.data);
          }
        }
      };
      const supResponse = await getAllSuppliers(token);
      const suppliersToRemove = [];
      if (rfqData?.quotationId) {
        const offerDetailsId = await getOfferSupplierDetailsByQuoteId(rfqData?.quotationId);
        if (offerDetailsId?.payload && Array.isArray(offerDetailsId?.payload)) {
          offerDetailsId?.payload.forEach((item) => {
            suppliersToRemove.push(item?._id);
          });
        }

      };
      console.log("Supplier to remove :", suppliersToRemove);
      if (supResponse.status) {
        let filteredSupplierData = supResponse.data.filter(
          (item) => item.status == "Active" && !suppliersToRemove.includes(item._id)
        );
        console.log("Data :", filteredSupplierData);
        setSupplierList(filteredSupplierData);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(
        "Error in 187 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
      toast.error("Something went wrong while fetching RFQ data.");
    }
  };

  // console.log(rFQData);

  const handleAddManualClick = async () => {
    handleLineItemModalClick();
    await handleNewRowCreating();
  }
  const handleAddFromQuoteClick = () => {
    setIsQuoteListModalOpen(true);
  }

  const handleCreatePurchaseOrder = async (rfqSelectedForPO) => {
    try {
      let formData = new FormData();
      const organizationResponse = await fetchOrganzationDetails(token);
      let organizationData = organizationResponse?.data;
      if (!organizationData.organizationAddress) {
        toast.error("Organization address not found. Please update in organization setup menu.");
        return;
      }

      formData.append("rfqData", JSON.stringify(rfqSelectedForPO));
      formData.append("shippingAddress", JSON.stringify({ ...organizationData?.organizationAddress, postalCode: organizationData?.organizationAddress?.zipCode, firstName: organizationData?.organizationName }));
      const poResponse = await createPurchaseOrder(formData, token);
      if (poResponse?.data?.status) {
        toast.success(poResponse?.data?.message);
        navigate(
          `/admin/purchase-order-details/${poResponse?.data?.data?._id}`
        );
      } else {
        toast.error(poResponse?.data?.message);
      }
    } catch (err) {
      console.log(
        "Error in 257 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleUpdateRFQPartData = async () => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this rfq.");
      return;
    }

    let userResponse;

    if (rFQData.rfqOfferStatus == 'cancelled') {
      userResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Move RFQ to In Progress',
          content: 'Do you want to move the RFQ to In Progress status?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
    }
    let isQuantityNotValid = validateQuantity();
    if (isQuantityNotValid) {
      toast.error("Quantity should not be zero");
      return;
    }
    setIsLoading(true);
    try {
      if (userResponse) {
        const response = await activateRFQ(token, rFQData._id);
        if (!response.success) {
          console.log(response);
          setIsLoading(false);
          toast.error("Unable to change RFQ status");
          return;
        }
      };


      let data = {
        id: rFQData._id,
        adminComment: rFQData.adminComment,
      };
      await updateRFQAdminComment(token, data);


      const newRfqData = { ...rFQData, Import3D: is3DFileOn, Import2D: is2DFileOn };
      delete newRfqData.rfqOfferStatus;
      let formData = new FormData();
      formData.append("updatedRFQ", JSON.stringify(newRfqData));

      let updatedRFQResponse = await updateRFQPartsData(formData, token);
      if (updatedRFQResponse?.data?.status) {
        await fetchData();
        toast.success(updatedRFQResponse?.data?.message);
      } else {
        toast.error(updatedRFQResponse?.data?.data?.message);
      }
    } catch (err) {
      console.log(
        "Error in 287 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      )
    } finally {
      setIsLoading(false);
      setIsAnyUnsavedChange(false);
      setIsSave(false);
    }
  };

  const handleSelectedFileRemove = async (index, fileType) => {
    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Confirm RFQ Update',
        content: 'Once the file is deleted, it cannot be accessed again. Are you sure you want to update the RFQ?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (!adminResponse) {
      return;
    }
    let data = {
      rfqOfferId: rFQData._id,
      fileType,
      partIndex: index,
    };

    let response = await deleteFileFromRFQ(data, token);


    if (response.status) {
      const newRFQData = { ...rFQData };
      if (fileType == "2D") {
        newRFQData.partsData[index].twoDFile = null;
        setIs2DFileOn(false);
      }
      else {
        newRFQData.partsData[index].selectedFile = null;
        newRFQData.partsData[index].thumbnail = null;
        newRFQData.partsData[index].gltfPlainFileUrl = null;
        newRFQData.partsData[index].gltfColoredFileUrl = null;
        newRFQData.partsData[index].stagingPartsDataId = null;
        setIs3DFileOn(false);
      }
      setRFQData(newRFQData);
      toast.success("File deleted successfully");
    } else {
      toast.error("Something went wrong while uploading files.");
    }
  };


  const handleFileUpload = async (event, index, fileType) => {
    const file = event.target.files[0];
    try {
      setIsLoading(true);
      let formData = new FormData();
      console.log('cam ehere')
      formData.append("rfqOfferId", rFQData?._id);
      formData.append("fileType", fileType);
      if (fileType == "2D") {
        formData.append("selected2DPartFile", file);
      } else {
        // starting quaoar flow
        const isFileNameValid = isValidFileName(file?.name || file?.path);
        console.log("is Valid ::", isFileNameValid);
        if (isFileNameValid) {
          const response = await processFileWithAnalysis(file, (queueStatus) => {
            console.log("Quotation status ::", queueStatus);
          });
          const dataReceivedFromResponse = response.data?.result;
          const analysisData = {
            s3QrFileUrl: dataReceivedFromResponse?.filesS3Data || null,
            jsonFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[0]?.json || null,
            thumbnail: dataReceivedFromResponse?.quaoarResponseFiles?.[1]?.png || null,
            gltfPlainFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[2]?.glb?.[0] || null,
            gltfColoredFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[2]?.glb?.[1] || null,
            stagingPartsData: dataReceivedFromResponse?.stagingPartResponse || "",
          };
          console.log("Data ::", analysisData);
          formData.append("analysisData", JSON.stringify(analysisData));
        }

        formData.append("selected3DPartFile", file);
      }
      formData.append("partIndex", index);

      let response = await uploadFileToRFQ(formData, token);




      if (response.status) {
        //only update selected file at selected index
        const newRFqData = { ...rFQData };
        if (fileType == "2D") {
          newRFqData.partsData[index].twoDFile = response?.data?.partsData[index]?.twoDFile;
          setIs2DFileOn(response?.data?.Import2D);
        } else {
          newRFqData.partsData[index].selectedFile = response?.data?.partsData[index]?.selectedFile;
          newRFqData.partsData[index].thumbnail = response?.data?.partsData[index]?.thumbnail;
          newRFqData.partsData[index].gltfPlainFileUrl = response?.data?.partsData[index]?.gltfPlainFileUrl;
          newRFqData.partsData[index].gltfColoredFileUrl = response?.data?.partsData[index]?.gltfColoredFileUrl;
          if (response?.data?.partsData[index]?.stagingPartsDataId && typeof response?.data?.partsData[index]?.stagingPartsDataId == 'string') {

            const res = await getDFMInfo([response?.data?.partsData[index]?.stagingPartsDataId].filter(Boolean));
            const dfmData = res?.data;
            newRFqData.partsData[index].stagingPartsDataId = dfmData[response?.data?.partsData[index]?.stagingPartsDataId];
          }
          // newRFqData.partsData[index].stagingPartsDataId = await getDFMInfo([response?.data?.partsData[index]?.stagingPartsDataId].filter(Boolean));
          setIs3DFileOn(response?.data?.Import3D);
        }
        setRFQData(newRFqData);
        setIsSave(true);
        // toast.success("File uploaded successfully");
      } else {
        toast.error("Something went wrong while uploading files.");
      }
    } catch (err) {
      console.log(
        "Error in 316 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handlePartNameChange = (e, index) => {
    let localRFQPartsData = [...rFQData.partsData];
    localRFQPartsData[index].partName = e.target.value;
    setIsPartsNameChanged(true);
    setRFQData({ ...rFQData, partsData: localRFQPartsData });
  };

  const handlePartNotesChange = (e, index) => {
    let localRFQPartsData = [...rFQData.partsData];
    localRFQPartsData[index].partNotes = e.target.value;
    setIsPartsNameChanged(true);
    setRFQData({ ...rFQData, partsData: localRFQPartsData });
  };

  const handleRFQItemQtyChange = (e, i) => {
    const newQty = e.target.value;
    const isEmpty = newQty === "";
    const isNaturalNumber = /^[1-9][0-9]*$/.test(newQty);
    if (!isEmpty && !isNaturalNumber) {
      return;
    }

    setIsAnyUnsavedChange(true);
    let localRFQPartsData = rFQData;
    localRFQPartsData.partsData[i].qty = newQty;
    setRFQData({ ...localRFQPartsData });
  };

  const handleRFQItemDescChange = (event, i) => {
    setIsAnyUnsavedChange(true);
    let localRFQPartsData = rFQData;
    localRFQPartsData.partsData[i].description = event.target.value;
    setRFQData({ ...localRFQPartsData });
  };

  const handleAddSupplier = async () => {
    if (isPOAlreadyExists) {
      toast.error("Purchase order is already created for this rfq.");
      return;
    }
    if (!selectedSupplier) {
      toast.error("Select a valid supplier");
      return;
    }
    const isSupplierSelected = supplierRFQs.some(
      (rfq) => rfq.supplierId._id == selectedSupplier._id
    );
    if (isSupplierSelected) {
      toast.error("Supplier is already selected.");
      return;
    }
    handleCreateSupplierRFQ();
  };

  const validatePartsName = () => {
    try {
      let partsData = rFQData.partsData;
      let isValid = true;

      for (let i = 0; i < partsData.length; i++) {
        if (partsData[i]?.partName?.length == 0 || !partsData[i].partName) {
          isValid = false;
          break;
        }
      }
      return isValid;
    } catch (err) {
      toast.error(err.message);
      return false;
    }
  };

  const validateQuantity = () => {
    const partsData = rFQData.partsData;
    return partsData.some((item) => Number(item.qty) <= 0)
  }
  const handleCreateSupplierRFQ = async () => {
    setIsLoading(true);
    try {

      let data = {
        supplierId: selectedSupplier._id,
        rfqOfferId: _id,
      };
      const supplierRFQResponse = await createSupplierRFQ(token, data);
      console.log("Suppied RFQ response: ", supplierRFQResponse);
      if (supplierRFQResponse.status) {
        toast.success("Supplier added successfully");
        setSupplierRFQs([...supplierRFQs, supplierRFQResponse.data]);
        if (rFQData.rfqOfferStatus === 'cancelled') {
          setRFQData({ ...rFQData, rfqOfferStatus: 'in-progress' });
        }
      }
    } catch (err) {
      // console.log(
      //   "Error in 371 RFQ Details on " +
      //   moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
      //   err
      // );
      console.log("Error :", err);
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateRfQClick = async () => {
    setShowRfqModal(false);
    try {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Update RFQ Information',
          content: 'Are you sure you want to update the RFQ information? Once updated, the RFQ will be moved to "Under Review" status.',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (adminResponse) {
        setShowRfqModal(true);
        let isRFQDataValid = validateRFQData();
        if (isRFQDataValid) {
          setSupplierRFQUpdaing(true);
          let dataToSend = {
            partsData: rFQtoShow.partsData,
            leadTime: rFQtoShow.leadTime,
            price: rFQtoShow.price,
            _id: rFQtoShow._id,
          };
          let updatedRFQResponse = await handleUpdateRfQ(
            { ...dataToSend },
            token
          );
          let localRFQForQuotation = [...supplierRFQs];
          for (let i = 0; i < localRFQForQuotation.length; i++) {
            if (
              localRFQForQuotation[i]._id == updatedRFQResponse.data.data._id
            ) {
              localRFQForQuotation[i] = updatedRFQResponse.data.data;
              break;
            }
          }
          if (updatedRFQResponse.data.status) {
            toast.success(updatedRFQResponse.data.message);
            setSupplierRFQs(localRFQForQuotation);
            setShowRfqModal(false);
          } else {
            toast.error(updatedRFQResponse.data.data.message);
          }
        } else {
          toast.error("Item price and lead time are required fields.");
        }
      }
    } catch (err) {
      console.log(
        "Error in 405 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
    finally {
      setSupplierRFQUpdaing(false);
      setShowRfqModal(false);

    }
  };

  const handleDeleteRFQ = async (id) => {
    try {
      let adminResponse1 = true;
      adminResponse1 = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Delete Supplier',
          content: 'If you delete this supplier, the RFQ will no longer be valid. Are you sure you want to proceed with deleting it?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (adminResponse1) {
        const deleteResponse = await deleteRFQ(id, token);
        if (deleteResponse.data.status) {
          let localRFQForQuotation = [...supplierRFQs];
          localRFQForQuotation = localRFQForQuotation.filter(
            (item) => item._id != id
          );
          setSupplierRFQs([...localRFQForQuotation]);
          toast.success(deleteResponse.data.message);
        } else {
          toast.error(deleteResponse.data.message);
        }
      }
    } catch (err) {
      console.log("Error in delete rfq", err.message);
    }
  };

  const handleRFQDownload = async (rfqData, i) => {
    console.log("Index ::", i);
    setDownloadingRFQIndex(i)
    try {
      let response = await downloadRfq(rfqData._id, token);
      const data = response.data;
      console.log('Data ::', data)
      if (data.success) {
        const signedUrl = data.signedUrl;
        console.log("Signed Url ::", signedUrl);
        setPdfModalInfo({
          show: true,
          fileName: `RFQ-${rfqData.supplierRFQRefId}.pdf`,
          pdfUrl: signedUrl,
        });
      }
      else {
        throw new Error('Unable to download RFQ at the moment');
      }

    } catch (err) {
      console.error(
        "Error in handleRFQDownload on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
    finally {
      setIsDownloadRfq(false);
      setDownloadingRFQIndex(null);
    }
  };
  const validateRFQData = () => {
    let isDataValid = true;
    let isPriceAvailable = false;
    for (let i = 0; i < rFQtoShow.partsData.length; i++) {
      if (rFQtoShow.partsData[i].price > 0) {
        isPriceAvailable = true;
        break;
      }
    }

    if (isPriceAvailable) {
      isDataValid = true;
    } else {
      isDataValid = false;
    }

    if (!rFQtoShow.leadTime) {
      isDataValid = false;
    }
    return isDataValid;
  };

  const handleRFQItemPriceChange = (event, index) => {
    let localRFQPartsData = [...rFQtoShow.partsData];
    localRFQPartsData[index].price = event.target.value;

    let totalPrice = localRFQPartsData?.reduce((acc, item) => {
      return acc + item.price * item.qty;
    }, 0);

    setRFQToShow({
      ...rFQtoShow,
      partsData: localRFQPartsData,
      price: totalPrice,
    });
  };

  const handleSendRFQMail = async (rFQId, emails) => {
    try {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Send RFQ to Supplier',
          content: 'Are you sure you want to send this RFQ to the supplier?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (adminResponse) {
        let response = await sendRFQToSupplier(rFQId, token, emails);
        let localRFQForQuotation = [...supplierRFQs];
        for (let i = 0; i < supplierRFQs.length; i++) {
          if (localRFQForQuotation[i]._id == response.data._id) {
            localRFQForQuotation[i] = response.data;
          }
        }
        setSupplierRFQs([...localRFQForQuotation]);
        if (response.status) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      }
    } catch (err) {
      console.log(
        "Error in 505 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleMarkAsSentRFQ = async (supplierRfqOfferId) => {
    try {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Mark RFQ as Sent',
          content: 'Are you sure you want to mark this RFQ as sent?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (adminResponse) {
        let response = await markRFQAsSent(supplierRfqOfferId, token);
        let localRFQForQuotation = [...supplierRFQs];
        for (let i = 0; i < supplierRFQs.length; i++) {
          if (localRFQForQuotation[i]._id == response.data._id) {
            localRFQForQuotation[i] = response.data;
          }
        }
        setSupplierRFQs([...localRFQForQuotation]);
        if (response.status) {
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      }
    } catch (err) {
      console.log(
        "Error in 505 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleSwitchClick = async (rfqData) => {
    setIsDirty(false);
    try {
      if (rfqData.price <= 0 || !rfqData.price) {
        toast.error("The price for parts is not updated.");
        return;
      }
      if (!isDefaultOrganizationAddressExists) {
        toast.error("Please set a default organization address in the Organization setup before creating a purchase order. ");
        return;
      }

      let isOrderAlreadyCreated;
      supplierRFQs.forEach((item) => {
        if (item.isSelected) {
          isOrderAlreadyCreated = true;
        }
      });

      if (isOrderAlreadyCreated) {
        toast.error("Purchase order for this RFQ is already created.");
        return;
      }
      //check if related offer already created then don't let user create the po 
      if (rfqOfferAdditionalData?.poCreated) {
        toast.error("Purchase order already created from linked offer");
      }
      //notify the user linked offer is also created 


      if (rfqOfferAdditionalData?.rfqOffer?._id) {
        let adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Confirm Supplier Selection',
            content: `A linked offer is also created. Proceeding will cancel the existing offer and its related supplier offers. Are you sure you want to continue and create a Draft Purchase Order for ${rfqData?.supplierId?.companyName}?`,
            okText: 'Yes, Proceed',
            cancelText: 'Cancel',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });

        if (!adminResponse) {
          return;
        }


      }
      else {
        let adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Confirm Supplier Selection',
            content: `Are you sure you want to select ${rfqData?.supplierId?.companyName}? A Draft Purchase Order will be created on confirmation.`,
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });
        if (!adminResponse) {
          return;
        }
      }

      handleCreatePurchaseOrder(rfqData);
    } catch (err) {
      console.log(
        "Error in 523 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleCancelRFQ = async () => {
    setIsDirty(false);
    if (isPOAlreadyExists) {
      toast.error("Purchase order Is Already Created Unable to Cancel");
      return;
    }
    try {
      const adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Confirm Cancellation',
          content: `Are you sure you want to cancel for ${rFQData.projectName}? Note: All supplier RFQs will get cancelled for this project as well.`,
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!adminResponse) {
        return;
      }
      const cancelResponse = await cancelRFQ(_id, token);
      if (cancelResponse.status) {
        navigate(`/admin/admin-quote/${rFQData?.quotationId}`);
      }
    } catch (err) {
      console.log(
        "Error in 582 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleShowDeclinedDetails = (itemId) => {
    let declinedRFQData = supplierRFQs.filter((item) => item._id == itemId);
    setDeclinedRFQData(declinedRFQData[0]);
    setShowDeclineDescription(true);
  };

  const handleDeclineModalClose = () => {
    setShowDeclineDescription(false);
  };

  const handleRFQDocumentUpload = async (event, supplierRfqOfferId, index) => {
    try {
      let formData = new FormData();
      formData.append("supplierRfqOfferId", supplierRfqOfferId);
      formData.append("rfqOfferDocument", event.target.files[0]);

      let response = await uploadRFQDocumentByAdmin(token, formData);
      if (response.status) {
        // setRFQData({...rFQData,partsData:response?.data?.partsData})
        let localSupplierRFQs = [...supplierRFQs];
        localSupplierRFQs[index] = response.data;
        setSupplierRFQs(localSupplierRFQs);
        toast.success("RFQ document uploaded successfully");
      } else {
        toast.error("Something went wrong while uploading files.");
      }
    } catch (err) {
      console.log(
        "Error in 316 RFQ Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  console.log("Rfq Data :", rFQData);

  const handle3DFileChange = async (checked) => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this rfq.");
      return;
    }
    const newState = checked ? true : false;
    if (newState) {
      const confirmProceed = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Import 3D Files',
          content: (
            <>
              <p>All 3D files associated with the customer quotation will be imported directly.</p>
              <p style={{ fontWeight: 'bold', marginTop: 8 }}>
                Note: In the future, if any 3D file mismatches the customer quotation, the toggle to view the imported 3D file will be disabled for that entry.
              </p>
            </>
          ),
          okText: 'Proceed',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (!confirmProceed) return;
    }



    setIsAnyUnsavedChange(true);
    setIs3DFileOn(newState);
    if (newState) {

      setIsAnyFileImporting(true);
      const response = await getQuotePartsDataById(rFQData?.quotationId);
      if (!response?.success) {
        toast.error("Failed to fetch quote parts data");
        return;
      };
      const quotePartsData = response?.data?.partsData;
      const updatedPartsData = rFQData.partsData.map(part => {
        if (quotePartsData.some((quotePart) => quotePart?._id == part?.mainPartDataId)) {
          const quotePartItem = quotePartsData.find((quotePart) => quotePart?._id == part?.mainPartDataId);
          const updatedPart = {
            ...part,
            selectedFile: quotePartItem?.selectedFile,
            thumbnail: quotePartItem?.thumbnail,
          };
          return updatedPart;
        };
        return part;
      });
      setRFQData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import3D: true,
      }));
      setIsAnyFileImporting(false);
    }
    else {
      const updatedPartsData = rFQData.partsData.map(part => {
        return {
          ...part,
          selectedFile: null,
          thumbnail: null
        };
      });
      setRFQData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import3D: false,
      }));
    }
    setIsSave(true);
  };

  const handle2DFileChange = async (checked) => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this rfq.");
      return;
    }
    const newState = checked ? true : false;
    if (newState) {
      const confirmImport2D = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Import 2D Files',
          content: (
            <>
              <p>All 2D files associated with the customer quotation will be imported directly.</p>
              <p style={{ fontWeight: 'bold', marginTop: 8 }}>
                Note: In the future, if any 2D file mismatches the customer quotation, the toggle to view the imported 2D file will be disabled for that entry.
              </p>
            </>
          ),
          okText: 'Proceed',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (!confirmImport2D) return;

    }



    setIsAnyUnsavedChange(true);
    setIs2DFileOn(newState);
    if (newState) {
      setIsAnyFileImporting(true);
      const response = await getQuotePartsDataById(rFQData?.quotationId);
      if (!response?.success) {
        toast.error("Failed to fetch quote parts data");
        return;
      };
      const quotePartsData = response?.data?.partsData;
      const updatedPartsData = rFQData.partsData.map(part => {
        if (quotePartsData.some((quotePart) => quotePart?._id == part?.mainPartDataId)) {
          const quotePartItem = quotePartsData.find((quotePart) => quotePart?._id == part?.mainPartDataId);
          const updatedPart = {
            ...part, twoDFile: quotePartItem?.twoDFile
          };
          return updatedPart;
        };
        return part;
      });
      setRFQData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import2D: true,
      }));
      setIsAnyFileImporting(false);
    }
    else {
      const updatedPartsData = rFQData.partsData.map(part => {
        return {
          ...part,
          twoDFile: null,
        };
      });
      setRFQData(prevState => ({
        ...prevState,
        partsData: updatedPartsData,
        Import2D: false,
      }));
    }
    setIsSave(true);
  };
  const handleSnapShotUpload = async (e, id, isSnapshotExists) => {
    //check if po is created or not 
    if (isSnapshotExists) {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Upload snapshot?',
          content: (
            <>
              <p>Are you sure you want to upload a new snapshot?</p>
              <p style={{ color: 'red', marginTop: 10 }}>
                Warning: This action will permanently replace the existing snapshot. The old snapshot cannot be recovered.
              </p>
            </>
          ),
          okText: 'Yes, Upload',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!adminResponse) return;

    }


    const file = e.target.files[0];
    const MAX_FILE_SIZE_MB = 10;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (!file) return;
    if (file.size > MAX_FILE_SIZE_BYTES) {
      toast.error(`File size exceeds ${MAX_FILE_SIZE_MB} MB limit.`);
      return;
    }
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed.");
      return;
    }


    if (!rFQData?._id) {
      toast.error("Please select a rfq to upload snapshot.");
      return;
    }
    const formData = new FormData();
    formData.append("snapshot", file);
    formData.append("item_id", id);
    formData.append("id", rFQData._id);
    try {
      setIsLoading(true);

      const response = await uploadPartSnapShotDataOfferRFQ(token, formData);
      if (!response.success) {
        throw new Error();
      }
      const { url } = response;
      setRFQData((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item) => {
            if (item._id == id) {
              return {
                ...item,
                thumbnail: url
              }
            } else {
              return item;
            }
          })
        }
      });




    } catch (error) {
      console.log("Error ::", error);
      toast.error("Unable to upload snapshot at the moment.");
    }
    finally {
      setIsLoading(false);

    }

  }
  const handleDeleteSnapshot = async (id) => {
    if (purchaseOrder._id) {
      toast.error("Purchase order is already created for this rfq.");
      return;
    }

    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Delete Snapshot?',
        content: (
          <>
            <p>Are you sure you want to delete this snapshot?</p>
            <p style={{ color: 'red', marginTop: 10 }}>
              Warning: This action will permanently delete the current snapshot and it cannot be recovered.
            </p>
          </>
        ),
        okText: 'Yes, Delete',
        cancelText: 'Cancel',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

    if (!adminResponse) return;


    const data = {
      item_id: id,
      id: rFQData?._id,
    }
    try {
      setIsLoading(true);

      const response = await deletePartSnapShotDataOfferRFQ(token, data);
      console.log("response from delte ::", response);
      if (!response.success) {
        throw new Error();
      }
      setRFQData((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item) => {
            if (item._id == id) {
              console.log("setting null ::");
              return {
                ...item,
                thumbnail: ''
              }
            } else {
              return item;
            }
          })
        }
      });

    } catch (error) {
      console.log("Error123 ::", error);
      toast.error("Unable to upload snapshot at the moment.");
    }
    finally {
      setIsLoading(false);

    }

  }

  return (
    <div
      className="admin-container"
      style={{
        width: "100%",
        overflowX: "auto",
        backgroundColor: "#f4e6dd",
        minHeight: "100vh",
      }}
    >
      {isAnyUnsavedChanges ? <BackButtonWarning
        warning={'"Are you sure you want to go back? There are unsaved changes."'} /> : null}
      {/* {isLoading ? <Loading /> : ""} */}
      <GenericLoaderComponent
        isLoading={isLoading}
      />
      <Sidebar />
      <CaptchaModal
        showModal={showCaptchaModal}
        handleClose={handleCloseCaptchaModal}
        handleSendEmail={() => captchaCallback?.()}
        buttonText={buttonText}
      />
      <RFQOfferEditProjectName
        show={showRfqOfferEditProjectName}
        currentName={rFQData?.projectName}
        onCancel={() => { setShowRfqOfferEditProjectName(false); }}
        onSave={handleProjectNameEdit}

      />
      <PDFModalViewer
        show={pdfModalInfo.show}
        fileName={pdfModalInfo.fileName}
        pdfUrl={pdfModalInfo.pdfUrl}
        handleClose={() => {
          setPdfModalInfo({
            show: false, fileName: "", pdfUrl: ""
          });
        }
        }
      />
      {isAnyFileImporting ? <FileImportModal
      /> : null}
      <EmailModal
        show={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSubmit={(email) => {
          console.log("Selected/Entered Email:", email);
          setShowCaptchaModal(true);
          setCaptchaCallback(() => () => handleSendRFQEmail(selectedRFQForMail, email));
          setIsModalVisible(false);
        }}
        buttonText="Send"
        category="RFQ"
        emailList={selectedEmailListForSupplier}
      />
      <Modal
        size="sm"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showDeclineDescription}
        onHide={handleDeclineModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            RFQ Decline Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="issue-description-div">
            <div>
              <h5>Reason to decline : </h5>
              <p>{declinedRFQData.declineReason}</p>
              <h5>Description : </h5>
              <p>{declinedRFQData.declineDescription}</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="req-quote-btn" onClick={handleDeclineModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <span style={{ width: "100%" }}>
        <div className="center-heading">
          <h1 className="text-2xl font-bold mt-3">RFQ Details</h1>
          <div className="ps-10">
            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <label style={{ marginRight: "10px", fontSize: "16px", marginTop: "10px" }}>Import 3D files</label>
              <Switch
                className="custom-switch"
                on={true}
                off={false}
                value={is3DFileOn}
                onChange={handle3DFileChange} // Toggle state on change
                style={{ marginLeft: '10px' }}
                disabled={isAnyFileImporting}

              />
            </div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <label style={{ marginRight: "10px", fontSize: "16px", marginTop: "10px" }}>Import 2D files</label>
              <Switch
                className="custom-switch"
                on={true}
                off={false}
                value={is2DFileOn}
                onChange={handle2DFileChange} // Toggle state on change
                style={{ marginLeft: '10px' }}
                disabled={isAnyFileImporting}

              />
            </div>
          </div>
          <div className="right-container">
            <h5 className="text-left !mb-2 flex items-center gap-x-2 ">
              {rFQData?.projectName ?
                <Fragment>     <span> Project Name : {rFQData?.projectName}{" "}  {rFQData?.rfqOfferStatus == "cancelled" ? "(Cancelled)" : ""}</span>
                  <span onClick={() => {
                    if (purchaseOrder._id) {
                      toast.error("Purchase order is already created for this rfq.");
                      return;
                    }
                    setShowRfqOfferEditProjectName(true)
                  }}>
                    <EditIcon
                      additionalClass={'h-4 cursor-pointer '}
                    />
                  </span></Fragment> : null}
            </h5>


            <div className="quotes-table">
              <table className="table">
                <thead>
                  <tr style={{ fontSize: "0.9rem" }}>
                    <th scope="col">Snapshot  </th>
                    <th scope="col">Files</th>
                    {/* <th scope="col">2D File</th> */}
                    <th scope="col">Part Description</th>
                    <th scope="col">Qty</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rFQData?.partsData?.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        style={{ fontSize: "0.9rem" }}
                        className="!bg-white"
                      >
                        <td className="flex items-center justify-center !border-b-0">
                          <p className="text-sm bold">
                            {
                              !isDfmInfoLoading ?
                                <ThreeDViewerComponent
                                  item={item}
                                  selectedProcess={rFQData?.selectedProcess}
                                  additionalClasses={'border !border-0'}
                                /> : <div className="flex items-center justify-center"><LucidLoader /></div>
                            }
                            <div class="flex items-start justify-start gap-x-2 ms-2 mt-3 w-full">
                              <button
                                onClick={() => {
                                  //check condition 
                                  if (purchaseOrder._id) {
                                    toast.error("Purchase order is already created for this rfq.");
                                    return;
                                  }
                                  if (item?.selectedFile) {
                                    //user have file
                                    inputRefs.current[index]?.click();
                                  }
                                  else {
                                    toast.error('Please upload a 3D file before adding a snapshot.');
                                  }
                                }
                                }
                                class={`cursor-pointer text-center rounded text-[12px] text-black bg-gray-200 shadow-md py-2 px-3 transition duration-300 ${item?.thumbnail ? 'w-1/2' : 'w-full'
                                  }`}
                              >
                                Upload
                              </button>
                              <input
                                ref={(ref) => inputRefs.current[index] = ref}
                                onChange={(e) => handleSnapShotUpload(e, item?._id, !!item?.thumbnail)}
                                id={`file-upload-${index}`}
                                type="file"
                                accept="image/*"
                                class="hidden"
                              />

                              {item?.thumbnail && (
                                <button
                                  onClick={() => handleDeleteSnapshot(item?._id)}
                                  class="w-1/2 text-center rounded text-[12px] text-white bg-red-500 hover:bg-red-600 shadow-md py-2 px-3 transition duration-300"
                                >
                                  Delete
                                </button>
                              )}
                            </div>

                          </p>
                        </td>

                        <td
                          style={{
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="min-w-[150px]"
                        >
                          <div className="space-y-4">

                            {/* 3D File Section */}
                            <div>
                              {item?.selectedFile?.originalname ? (

                                <FileName
                                  fileName={item.selectedFile.originalname}
                                  onDownload={async () => {
                                    const { originalname } = item?.selectedFile;
                                    if (originalname && originalname.endsWith('.pdf')) {
                                      const signedUrl = await getPresignedUrlForFile(item?.selectedFile.bucket, item?.selectedFile.key);
                                      console.log('Signed URL for PDF:', signedUrl);
                                      setPdfModalInfo({
                                        show: true,
                                        pdfUrl: signedUrl,
                                        fileName: originalname,
                                      })
                                      return;
                                    }
                                    await downloadFileFromS3(item.selectedFile)
                                  }}
                                  onDelete={() => {
                                    if (purchaseOrder._id) {
                                      toast.error("Purchase order is already created for this rfq.");
                                      return;
                                    }
                                    setShowCaptchaModal(true);
                                    setCaptchaCallback(() => () => {
                                      handleSelectedFileRemove(index, "3D")
                                    });
                                    setButtonText('Delete');
                                  }}
                                />
                              ) : (
                                <div style={{ color: "red" }}>
                                  <label
                                    className="white-btn cursor-pointer"
                                    onClick={() => {
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this rfq.");
                                        return;
                                      }
                                    }
                                    }
                                    htmlFor={!purchaseOrder._id ? `upload-3d-${index}` : undefined}
                                  >
                                    <span><UploadIcon additionalClass={'h-4'} /></span>
                                    <span className="mx-2">Upload 3D File for : Line {index + 1}</span>
                                  </label>
                                  <input
                                    disabled={purchaseOrder._id}
                                    id={`upload-3d-${index}`}
                                    type="file"
                                    onChange={(e) => {
                                      const files = Array.from(e.target.files);
                                      const isValid = files.every((file) => file.size <= 10485760);

                                      if (!isValid) {
                                        toast.error("File size should be less than 10 MB");
                                        return;
                                      }
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this rfq.");
                                        return;
                                      }

                                      handleFileUpload(e, index, "3D");
                                    }}
                                    style={{ visibility: "hidden", height: "0px", width: "0px" }}
                                  />
                                </div>
                              )}
                            </div>

                            {/* 2D File Section */}
                            <div>
                              {item?.twoDFile?.originalname ? (
                                <div>
                                  <p className="flex flex-wrap items-center gap-x-2">
                                    <FileName
                                      fileName={item.twoDFile.originalname}
                                      onDownload={async () => {
                                        const { originalname } = item?.twoDFile;
                                        if (originalname && originalname.endsWith('.pdf')) {
                                          const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                          console.log('Signed URL for PDF:', signedUrl);
                                          setPdfModalInfo({
                                            show: true,
                                            pdfUrl: signedUrl,
                                            fileName: originalname,
                                          })
                                          return;
                                        }
                                        await downloadFileFromS3(item?.twoDFile)
                                      }}
                                      onDelete={() => {
                                        if (purchaseOrder._id) {
                                          toast.error("Purchase order is already created for this rfq.");
                                          return;
                                        }
                                        setShowCaptchaModal(true);
                                        setCaptchaCallback(() => () => {
                                          handleSelectedFileRemove(index, "2D")
                                        });
                                        setButtonText('Delete');
                                      }}
                                    />
                                  </p>
                                </div>
                              ) : (
                                <div style={{ color: "red" }}>
                                  <label
                                    className="white-btn cursor-pointer"
                                    onClick={() => {
                                      if (purchaseOrder._id) {
                                        toast.error("Purchase order is already created for this rfq.");
                                        return;
                                      }
                                    }}
                                    htmlFor={!purchaseOrder?._id ? `upload-2d-${index}` : undefined}
                                  >
                                    <span><UploadIcon additionalClass={'h-4'} /></span>
                                    <span className="mx-2"> Upload 2D File for : Line {index + 1}</span>
                                  </label>
                                  <input
                                    id={`upload-2d-${index}`}
                                    type="file"
                                    onChange={(e) => {
                                      const files = Array.from(e.target.files);
                                      const isValid = files.every((file) => file.size <= 10485760);

                                      if (!isValid) {
                                        toast.error("File size should be less than 10 MB");
                                        return;
                                      }
                                      handleFileUpload(e, index, "2D");
                                    }}
                                    style={{ visibility: "hidden", height: "0px", width: "0px" }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </td>


                        <td

                          style={{
                            textAlign: "left",
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                            minWidth: "200px",
                          }}
                        >
                          {rFQData.selectedProcess > 2 ? (
                            <>
                              <textarea
                                className="border px-1"
                                disabled={purchaseOrder._id}

                                col="10"
                                row="5"
                                style={{ width: "100%" }}
                                value={item.description ? item.description : ""}
                                placeholder="Enter description"
                                onChange={(e) =>

                                  handleRFQItemDescChange(
                                    e,
                                    index,
                                    "description"
                                  )
                                }
                              />
                            </>
                          ) : (
                            <>
                              <div
                                className="desc-part"
                                style={{ minWidth: "220px" }}
                              >
                                <input
                                  disabled={purchaseOrder._id}
                                  style={{ width: "100%" }}
                                  className="border px-1"
                                  value={
                                    item.description ? item.description : ""
                                  }
                                  placeholder="Enter description"
                                  onChange={(e) =>
                                    handleRFQItemDescChange(
                                      e,
                                      index,
                                      "description"
                                    )
                                  }
                                />
                                {isMaterialDataLoading ? (
                                  <div className="flex items-center justify-center"><LucidLoader /></div>
                                ) : (
                                  <>
                                    {rFQData?.selectedProcess === 1 && (
                                      <MetaDataInfoCncComponent
                                        item={item}
                                        fullMastersData={allCncMachineData}
                                        allData={fullMastersData}
                                        index={index}
                                        onSaveClick={handleMetaDataSave}
                                        isEditEnabled={!isPOAlreadyExists}
                                      />
                                    )}
                                    {rFQData?.selectedProcess === 2 && (
                                      <MetaDataInfoThreeDComponent
                                        item={item}
                                        masterThreeDTechnologyData={masterThreeDTechnologyData}
                                        index={index}
                                        onSaveClick={handleMetaDataSave}
                                        isEditEnabled={!isPOAlreadyExists}
                                      />
                                    )}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </td>
                        <td>
                          <input
                            disabled={purchaseOrder._id}
                            className="p-1  border outline-none max-w-[80px]"
                            value={item.qty}
                            placeholder="Quantity"
                            type="text"
                            onWheel={numberInputOnWheelPreventChange}
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleRFQItemQtyChange(e, index)}
                          />
                        </td>
                        <td >
                          <div className="flex flex-col items-center justify-center gap-y-2  ">
                            <button className="px-2 py-0.5 text-sm bg-red-500 min-w-[70px] text-white rounded mx-1" onClick={() => {
                              if (purchaseOrder._id) {
                                toast.error("Purchase order is already created for this rfq.");
                                return;
                              }
                              handleDeleteRow(index)
                            }}>Del</button>
                            <button className="px-2 py-0.5 text-sm bg-yellow-400 min-w-[70px] text-white rounded " onClick={() => {
                              if (purchaseOrder._id) {
                                toast.error("Purchase order is already created for this rfq.");
                                return;
                              }
                              handleClone(index)
                            }}>Clone</button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div style={{ textAlign: "left" }}>
                <h6 className="font-medium my-1 p-2">Admin Comments :&nbsp;&nbsp;</h6>
                <textarea
                  disabled={purchaseOrder?._id}
                  rows="3"
                  className="p-1 outline-none"
                  style={{ width: "100%" }}
                  placeholder="Enter comment here"
                  value={rFQData?.adminComment}
                  onChange={(e) =>
                    setRFQData({ ...rFQData, adminComment: e.target.value })
                  }
                ></textarea>
              </div>

              <div style={{ textAlign: "left", marginBottom: "20px" }}>
                <button
                  className="common-supplier-button"
                  onClick={handleUpdateRFQPartData}
                >
                  Update RFQ data{" "}
                </button>
                {!isBatchFileDownloading ? <button
                  className=" max-w-[300px] bg-[#DC712B] text-white text-sm rounded px-2.5 py-1.5 transition duration-400 no-underline border-none mt-1.5 mr-2 ml-auto whitespace-nowrap !w-[400px]"
                  onClick={handleBatchClick}
                >
                  Batch download all technical drawings

                </button> : <button
                  className=" max-w-[300px] bg-[#DC712B] text-white text-sm rounded px-2.5 py-1.5 transition duration-400 no-underline border-none mt-1.5 mr-2  !w-[300px]"
                  onClick={handleBatchClick}
                >
                  <div className="mx-auto mt-2"><LucidLoader /></div>


                </button>}
                {!purchaseOrder?._id ? <button className="common-supplier-button" onClick={handleLineItemModalClick}>
                  Add line item
                </button> : null}
                <Link
                  to={`/admin/admin-quote/${rFQData?.quotationId}`}
                  className="common-supplier-button  hover:text-white"
                >
                  Go to quotation
                </Link>



                {!isPOAlreadyExists && <button
                  className="common-supplier-button"
                  onClick={handleCancelRFQ}
                >
                  Delete RFQ{" "}
                </button>}
                {rfqOfferAdditionalData?.rfqOffer?._id ? <button
                  className="common-supplier-button"
                  onClick={() => navigate('/admin/offers-details/' + rfqOfferAdditionalData?.rfqOffer?._id)}
                >
                  Go to linked offer
                </button> : null}
                {purchaseOrder._id ? (
                  <>
                    <button
                      className="common-supplier-button"
                      onClick={ErrorCheckHOF(() =>
                        navigate(
                          `/admin/purchase-order-details/${purchaseOrder._id}`
                        ))
                      }
                    >
                      Go to PO{" "}
                    </button>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "50%",
                flexWrap: "wrap",
              }}
            >
              <div>
                <Form.Select
                  onChange={(e) =>
                    setSelectedSupplier(JSON.parse(e.target.value))
                  }
                  defaultValue="default"
                  style={{ minWidth: "400px", marginTop: "10px" }}
                >
                  <option disabled value="default">
                    Select a supplier
                  </option>
                  {supplierList.map((item, i) => {
                    return (
                      <option key={i} value={JSON.stringify(item)}>
                        {item.companyName}
                      </option>
                    );
                  })}
                </Form.Select>
              </div>
              <div>
                <button
                  onClick={handleAddSupplier}
                  className="common-supplier-button"
                  style={{ minWidth: "150px", marginTop: "10px" }}
                >
                  Add Supplier
                </button>
              </div>
            </div>

            <br />
            {supplierRFQs.length > 0 ? (
              <>
                <table className="supplierTable">
                  <thead>
                    <tr>
                      <th>Choose Supplier</th>
                      <th>Supplier</th>
                      <th>Cost</th>
                      <th>LeadTime</th>
                      <th>Unit Price</th>
                      <th>Days since RFQ</th>
                      <th>RFQ Document</th>
                      <th>Download RFQ</th>
                      <th>Email</th>
                      <th>Chat</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {supplierRFQs.map((item, i) => {
                      console.log("Item ::", item?.supplierId);
                      return (
                        <tr key={i}>
                          <td
                            style={{
                              textAlign: "center",
                              wordWrap: "break-word",
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                              width: "30px",
                            }}
                          >
                            <Switch
                              className="custom-switch"
                              on="true"
                              off="false"
                              value={item?.isSelected?.toString()}
                              disabled={rFQData?.rfqOfferStatus === 'cancelled'}
                              onChange={() => handleSwitchClick(item)}
                            />
                          </td>
                          <td>
                            {item?.supplierId?.companyName}&nbsp;&nbsp; (
                            {item?.supplierId?.supplierRefId})
                          </td>
                          <td>
                            {item.price
                              ? currencyFormatter(item.price.toFixed(2))
                              : "NA"}
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              wordWrap: "break-word",
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                              width: "150px",
                            }}
                          >
                            {item?.leadTime ? (
                              <>
                                <p style={{ marginBottom: "0px" }}>
                                  {item?.leadTime + " Days"}{" "}
                                </p>
                                {`(${Math.floor(item?.leadTime / 7)}-${Math.floor(item?.leadTime / 7) + 1
                                  } weeks)`}
                              </>
                            ) : (
                              "NA"
                            )}
                          </td>
                          <td>
                            <button
                              onClick={() => {
                                handleRFQModelShow(item._id, item.status);
                              }}
                            >
                              Add/Edit
                            </button>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.receivedDate ? (
                              <>
                                {Math.abs(
                                  moment(item.receivedDate).diff(
                                    item?.quoteSubmitDate,
                                    "days"
                                  )
                                )}
                              </>
                            ) : (
                              <>
                                {Math.abs(
                                  moment(item.createdAt).diff(
                                    item?.quoteSubmitDate,
                                    "days"
                                  )
                                )}
                              </>
                            )}
                          </td>
                          <td>
                            {item.rfqOfferDocument ? (
                              <>
                                <div>
                                  <a
                                    className="text-primaryColor inline-block"
                                    onClick={async () => {
                                      const { originalname } = item.rfqOfferDocument;
                                      if (originalname && originalname.endsWith('.pdf')) {
                                        const signedUrl = await getPresignedUrlForFile(item.rfqOfferDocument.bucket, item.rfqOfferDocument.key);
                                        console.log('Signed URL for PDF:', signedUrl);
                                        setPdfModalInfo({
                                          show: true,
                                          pdfUrl: signedUrl,
                                          fileName: originalname,
                                        });
                                        return;
                                      }
                                      await downloadFileFromS3(item.rfqOfferDocument)
                                    }


                                    }
                                  >
                                    <span>
                                      {item.rfqOfferDocument.originalname}
                                    </span>
                                    <DownloadIcon additionalClass={'!h-4 inline-block'} />
                                  </a>
                                </div>
                              </>
                            ) : (
                              <>
                                <label
                                  className="rfq-doc-label text-center"
                                  htmlFor={!purchaseOrder?._id ? `rfq-doc-${i}` : undefined}
                                  onClick={() => {
                                    if (purchaseOrder._id) {
                                      toast.error("Purchase order is already created for this rfq.");
                                      return;
                                    }
                                  }}
                                >
                                  Upload
                                </label>
                                <input
                                  disabled={purchaseOrder?._id}
                                  id={`rfq-doc-${i}`}
                                  type="file"
                                  onChange={(e) => {

                                    let filesForCheck = Array.from(e.target.files);
                                    let isAllFilesValid = true;
                                    filesForCheck.forEach(file => {
                                      if (file.size > maxFileUploadSize) {
                                        isAllFilesValid = false;
                                      }
                                    })

                                    if (!isAllFilesValid) {
                                      toast.error("File size should be less than 10 MB");
                                      return;
                                    }
                                    handleRFQDocumentUpload(e, item?._id, i);
                                  }}
                                  style={{
                                    visibility: "hidden",
                                    height: "0px",
                                    width: "0px",
                                  }}
                                />
                              </>
                            )}
                          </td>
                          <td>
                            {downloadingRfqIndex != i ? <button onClick={() => handleRFQDownload(item, i)}>
                              Download
                            </button> : <button className="flex items-center justify-center" >
                              <LucidLoader />
                            </button>}
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              wordWrap: "break-word",
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                              minWidth: "150px",
                            }}
                          >
                            {" "}
                            {item.isReceived ? (
                              <>
                                RFQ Sent on{" "}
                                {moment(item.receivedDate).format(
                                  "MMM DD, YYYY"
                                )}
                                <p style={{ fontWeight: "bolder" }}>
                                  ({item.status})
                                  <br />
                                  {item.isDeclined ? (
                                    <>
                                      <button
                                        onClick={() =>
                                          handleShowDeclinedDetails(item._id)
                                        }
                                        style={{
                                          minWidth: "90px",
                                        }}
                                      >
                                        View Reason
                                      </button>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  {item.poCreationDate ? (
                                    <>
                                      {" "}
                                      Po created on{" "}
                                      {moment(item.poCreationDate).format(
                                        "MMM DD, YYYY"
                                      )}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </p>
                              </>
                            ) : (
                              <>
                                {item.status != 'Not Available' ?

                                  <Fragment><button
                                    onClick={() => {
                                      if (purchaseOrder?._id) {
                                        toast.error('Purchase order is already created for this rfq.');
                                        return;
                                      }
                                      setSelectedRFQForMail(item._id);
                                      // setShowCaptchaModal(true);
                                      setButtonText('Send email');
                                      // setCaptchaCallback(() => () => handleSendRFQEmail(item._id));
                                      setIsModalVisible(true);
                                      if (Array.isArray(item?.supplierId?.emailList)) {
                                        setSelectedEmailLIstForSupplier(item?.supplierId?.emailList);
                                      }
                                      else {
                                        setSelectedEmailLIstForSupplier([]);
                                      }
                                    }}
                                    style={{
                                      minWidth: "90px",
                                    }}
                                  >
                                    Send RFQ
                                  </button>

                                    <button
                                      onClick={() => {
                                        if (purchaseOrder._id) {
                                          toast.error("Purchase order is already created for this rfq.");
                                          return;
                                        }

                                        handleMarkAsSentRFQ(item._id)
                                      }}
                                      style={{
                                        minWidth: "90px",
                                        marginTop: "5px",
                                      }}
                                    >
                                      Mark As Sent
                                    </button>
                                  </Fragment> : <p style={{ fontWeight: "bolder" }}>
                                    ({item.status})
                                  </p>}
                              </>
                            )}
                          </td>
                          <td >
                            <Chat
                              RefId={item?.supplierRFQRefId}
                              open={item?.supplierRFQRefId == selectedChatRefId}
                              onDrawerClose={onClose}
                            />
                            {/* <button
                              onClick={() =>
                                showSupplierDrawer(item?.supplierRFQRefId)
                              }
                              // style={{ width: "100px", textAlign: "center" }}

                            > */}
                            <ChatButton
                              RefId={item?.supplierRFQRefId}
                              showDrawer={() =>
                                showSupplierDrawer(item?.supplierRFQRefId)
                              }
                              color={"white"}
                              additionalClass={'!bg-[#DC712B] hover:bg-[#bd5612]  w-max px-2 !h-8'}
                            />
                            {/* </button> */}
                          </td>
                          <td>
                            {!item?.isSelected ? <>
                              <button onClick={() => handleDeleteRFQ(item._id)}>
                                Delete
                              </button>
                            </> :
                              <>
                                PO Created
                              </>}

                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </span >

      <Modal
        size="lg"
        dialogClassName="!max-w-[90vw] !w-[90vw] mx-auto"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        show={showRfqModal}
        onHide={handleModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center font-bold text-xl w-[100%] mx-auto" >RFQ Details</Modal.Title>
        </Modal.Header>

        <Modal.Body className="!border !border-green-500">
          {/* Horizontal scroll container */}
          <div style={{ overflowX: "auto", width: "100%" }}>
            <table className="qoute-version-table w-full min-w-[1000px] table-fixed">
              <thead>
                <tr className="!py-3 !px-3 bg-slate-100 ">
                  <th className="!p-3 border border-slate-500">Snapshot</th>
                  <th className="!p-3 border border-slate-500">Files</th>
                  <th className="!p-3 border border-slate-500">Description</th>
                  <th className="!p-3 border border-slate-500">Supplier Notes</th>
                  <th className="!p-3 border border-slate-500 !w-[120px]">Unit Price</th>
                  <th className="!p-3 border border-slate-500 !w-[100px]">Qty</th>
                  <th className="!p-3 border border-slate-500 !w-[120px]">Amount</th>
                </tr>
              </thead>
              <tbody>
                {rFQtoShow?.partsData?.length > 0 &&
                  rFQtoShow.partsData.map((item, index) => {
                    console.log("RFQ data to show ::", item);
                    return <tr key={index}>
                      {/* Snapshot */}
                      <td  >
                        <p className="flex items-center  !h-44 justify-center">
                          <ThreeDViewerComponent
                            item={item}
                            selectedProcess={rFQData?.selectedProcess}
                            additionalClasses={'!border-0'}
                          />
                        </p>
                      </td>

                      {/* Files */}
                      <td style={{ minWidth: "160px" }}>
                        <div
                          className="flex flex-col gap-2 prd-thumb downloadables"
                          style={{ color: "dodgerblue" }}
                        >
                          {/* 3D File */}
                          <div className="flex items-center gap-2">
                            {item?.selectedFile?.originalname ? (
                              <>
                                <FileName
                                  fileName={item?.selectedFile?.originalname}
                                  onDownload={async () => {
                                    const { originalname } = item?.selectedFile;
                                    if (originalname && originalname.endsWith('.pdf')) {
                                      const signedUrl = await getPresignedUrlForFile(item?.selectedFile.bucket, item?.selectedFile.key);
                                      console.log('Signed URL for PDF:', signedUrl);
                                      setPdfModalInfo({
                                        show: true,
                                        pdfUrl: signedUrl,
                                        fileName: originalname,
                                      })
                                      setRFQToShow(null);
                                      setShowRfqModal(false);
                                      return;
                                    }
                                    await downloadFileFromS3(item.selectedFile)
                                  }
                                  }
                                />
                              </>
                            ) : (
                              <span style={{ color: "red" }}>
                                File Not Available
                              </span>
                            )}
                          </div>

                          {/* 2D File */}
                          <div className="flex items-center gap-2">
                            {item?.twoDFile?.originalname ? (
                              <>
                                <FileName
                                  fileName={item?.twoDFile?.originalname}
                                  onDownload={async () => {
                                    const { originalname } = item?.twoDFile;
                                    if (originalname && originalname.endsWith('.pdf')) {
                                      const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                      console.log('Signed URL for PDF:', signedUrl);
                                      setPdfModalInfo({
                                        show: true,
                                        pdfUrl: signedUrl,
                                        fileName: originalname,
                                      });
                                      setRFQToShow(null);
                                      setShowRfqModal(false);
                                      return;
                                    }
                                    await downloadFileFromS3(item?.twoDFile)
                                  }
                                  }
                                />
                              </>
                            ) : (
                              <span style={{ color: "red" }}>
                                File Not Available
                              </span>
                            )}
                          </div>
                        </div>
                      </td>

                      {/* Description */}
                      <td style={{ minWidth: "250px", wordBreak: "break-word" }}>
                        <div className="desc-part">

                          {item?.description && (
                            <span >
                              {item.description}
                            </span>
                          )}

                          {rFQData?.selectedProcess === 1 ? (
                            <MetaDataInfoCncComponent
                              item={item}
                              fullMastersData={allCncMachineData}
                              allData={fullMastersData}
                              index={index}
                              onSaveClick={handleMetaDataSave}
                              isEditEnabled={false}
                            />
                          ) : rFQData?.selectedProcess >= 3 ? null : (
                            <MetaDataInfoThreeDComponent
                              item={item}
                              masterThreeDTechnologyData={masterThreeDTechnologyData}
                              index={index}
                              onSaveClick={handleMetaDataSave}
                              isEditEnabled={false}
                            />
                          )}
                        </div>
                      </td>

                      {/* Supplier Notes */}
                      <td style={{ minWidth: "50px" }}>{item?.notes}</td>

                      {/* Unit Price */}
                      <td className="!w-[120px]">
                        <input
                          disabled={purchaseOrder?._id}
                          className="border p-1 !w-[100px]"
                          type="number"
                          placeholder="Cost"
                          value={item.price || ""}
                          onWheel={numberInputOnWheelPreventChange}
                          onKeyDown={(e) =>
                            ["e", "E", "+", "-"].includes(e.key) &&
                            e.preventDefault()
                          }
                          onChange={(e) => handleRFQItemPriceChange(e, index)}
                        />
                      </td>

                      {/* Qty */}
                      <td>
                        <p className="amt p-1">{item?.qty}</p>
                      </td>

                      {/* Amount */}
                      <td style={{ minWidth: "90px" }}>
                        <div className="amt">
                          <p className="un-fld">
                            {currencyFormatter(
                              Number((item.qty * item.price) || 0).toFixed(2)
                            )}
                          </p>
                        </div>
                      </td>
                    </tr>
                  })}

                {/* Lead Time Row */}
                <tr className="leadTimeRow">
                  <td colSpan={5}></td>
                  <td id="leadTimeTitle">Lead Time</td>
                  <td>
                    <div style={{ maxWidth: "80px" }}>
                      <input
                        disabled={purchaseOrder?._id}
                        className="un-fld border p-1"
                        type="text"
                        placeholder="Days"
                        value={rFQtoShow?.leadTime || ""}
                        onWheel={numberInputOnWheelPreventChange}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || /^[1-9][0-9]*$/.test(val)) {
                            setRFQToShow({ ...rFQtoShow, leadTime: val });
                          }
                        }}
                      />
                      <p>
                        {rFQtoShow?.leadTime
                          ? `(${rFQtoShow?.leadTime} business days)`
                          : "NA"}
                      </p>
                    </div>
                  </td>
                </tr>

                {/* Total Cost Row */}
                <tr className="leadTimeRow">
                  <td colSpan={5}></td>
                  <td id="leadTimeTitle">Total Cost</td>
                  <td>
                    <div className="amt">
                      <p>
                        {rFQtoShow?.price
                          ? currencyFormatter(Number(rFQtoShow?.price).toFixed(2))
                          : ""}
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {isRFQUpdatable ? (
            !isSupplierRFQUpdating ? <Button
              className="req-quote-btn supplierButton"
              onClick={handleUpdateRfQClick}
            >
              Update RFQ
            </Button> : <Button
              className="req-quote-btn supplierButton "

            >
              <LucidLoader />
            </Button>
          ) : <Button
            className="req-quote-btn supplierButton"
          >
            Po Created
          </Button>}
          <Button
            className="req-quote-btn supplierButton"
            onClick={handleModalClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={isAddLineItemModalShow} onHide={handleLineItemModalClick} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select an Option</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Would you like to add manually or add from the quote?</p>
        </Modal.Body>
        <Modal.Footer >
          <Button variant="secondary" onClick={async () => await handleAddManualClick()}>Add Manually</Button>
          <Button variant="secondary" onClick={() => handleAddFromQuoteClick()}>Add from Quote</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={isQuoteListModalOpen} onHide={handleQuoteListModalClick} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Table Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Snapshot</th>
                <th>3D File</th>
                <th>2D File</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                selectedQuote?.partsData.map((item) => {
                  return <tr>
                    <td>
                      {
                        item?.thumbnail ? <img className="h-20" src={item?.thumbnail} /> : <p>No preview available</p>
                      }
                    </td>
                    <td>{
                      item?.selectedFile?.originalname ? <p className="truncate">{item?.selectedFile?.originalname.slice(0, 25)}</p> : 'No filename available'
                    }</td>
                    <td>{item?.twoDFile?.originalname ? <p className="truncate">{item?.twoDFile?.originalname.slice(0, 25)}</p> : 'No filename available'}</td>
                    <td>
                      <Button className="!bg-complementaryPrimaryColor border-complementaryPrimaryColor" onClick={() => handleAddItemFromQuoteList(item)} size="sm">Add</Button>
                    </td>
                  </tr>
                })
              }


            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleQuoteListModalClick}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
};

export default RFQDetails;
